import React from "react";
import "./ChooseMinemi.css";

const ChooseMinemi = ({ loanApplyType }) => {
  return (
    <>
      <div id="choose-minemi-loan-eligibility" className="bg-transparent">
        <div id="list-of-documents-container">
          <div id="documents-content" className="bg-transparent">
            <div className="documents-content-container bg-transparent">
              <div className="content-box w-100 bg-transparent ">
                {" "}
                <div className="documents-text-box bg-transparent">
                  <div className="bg-transparent">
                    <div id="choose-minemi-head-box" className="bg-transparent">
                      <div className="choose-minemi-heading bg-transparent">
                        <h4 id="documents-heading" className="bg-transparent">
                          Why Choose MinEmi Loan?
                        </h4>
                      </div>
                    </div>
                    {loanApplyType === "pl" ? (
                      <div className="text-box bg-transparent">
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Get the best interest rates starting at 10.5% p.a.*
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            AI-based recommendations tailored to your credit
                            profile.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            No hidden fees - complete transparency guaranteed.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Fast approvals - get funds in as little as 24 hours.
                          </p>
                        </div>
                      </div>
                    ) : loanApplyType === "cl" ? (
                      <div className="text-box bg-transparent">
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Get interest rates starting 8.5% p.a.*
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Get interest rates starting 8.5% p.a.*
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            100% transparent process with no hidden charges.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Quick approvals - get your car loan in as little as
                            48 hours.
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="text-box bg-transparent">
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Your highest loan eligibility based on your credit
                            profile.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            The best interest rate to help you negotiate with
                            banks.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Insights on how banks evaluate your
                            creditworthiness.
                          </p>
                        </div>
                        <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                          <p className="symbol-para bg-transparent">#</p>
                          <p className="text-para bg-transparent">
                            Actionable tips to boost your loan approval chances.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="documents-image-box d-none d-md-block">
                  <div>
                    <img
                      className="documents-image"
                      src={Image}
                      alt="docuents-image"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseMinemi;
